import api from './api';

export const getActivityLog = (params = {}) => api.get('/api/activity', { params });
